import { createSlice } from '@reduxjs/toolkit';
import { GetAllEmployeeContracts } from './EmployeeContractorsApi';
import { toast } from 'react-toastify';
import {ResponseApi} from "../BaseApi";
import {t} from "i18next";

const employeeContractorSlice = createSlice({
    name: 'employeeContractor',
    initialState: {
        createContract: [],
        createContractWorkSchedule:[],
        createContractV1: [],
        updateContractV1: {},
        getZonetree: [],
        getAllContractors: [],
        getAllWorkSchdule: [],
        allEmployeeContractors: [],
        allEmployeeContracts: [],
        getWorkTimeAccess: [],
        contractorDownloadDocument: null,
        WorkShiftByContractID: [],
        contractAllStatus: [],
        approveContractorDocument: null,
        customSchdulTime: [],
        getVehicleWithDocumentById: [],
        getAllVehicleByContractorId: [],
        getEmployeeContractorById: {},

        getAllToContractor: [],
        createEmployeeContractor: {},
        getContractorById: {},
        getAllContractorDocuments: {},
        getAllCommonArea:null,
    },
    reducers: {
        customScduleTime: (state, { payload }) => {
            state.customSchdulTime = payload;
        },

        ClearGetContractorById: (state, action) => {
            state.getContractorById = {};
        },
    },
    extraReducers: {
        'employeeContractor/CreateContract/fulfilled': (state, action) => {
            state.createContract = ResponseApi(action.payload);
        },
        'employeeContractor/createContractWorkSchedule/fulfilled': (state, action) => {
            state.createContractWorkSchedule = ResponseApi(action.payload);
        },
        'employeeContractor/createContractV1/fulfilled': (state, action) => {
            state.createContractV1 = ResponseApi(action.payload);
        },
        'employeeContractor/updateContractV1/fulfilled': (state, action) => {
            state.updateContractV1 = ResponseApi(action.payload);
        },
        'employeeContractor/getEmployeeContractorById/fulfilled': (state, action) => {
            state.getEmployeeContractorById = ResponseApi(action.payload);
        },
        'employeeContractor/GetZoneTree/fulfilled': (state, action) => {
            state.getZonetree = ResponseApi(action.payload);
        },
        'employeeContractor/GetAllEmployeeContractors/fulfilled': (state, action) => {
            state.allEmployeeContractors = ResponseApi(action.payload);
        },
        'employeeContractor/GetAllContractors/fulfilled': (state, action) => {
            state.getAllContractors = ResponseApi(action.payload);
        },
        'employeeContractor/GetAllWorkSchdule/fulfilled': (state, action) => {
            state.getAllWorkSchdule = ResponseApi(action.payload);
        },
        'employeeContractor/GetWorkTimeAccess/fulfilled': (state, action) => {
            state.getWorkTimeAccess = ResponseApi(action.payload);
        },
        'employeeContractor/GetWorkShiftByContractID/fulfilled': (state, action) => {
            state.WorkShiftByContractID = ResponseApi(action.payload);
        },
        'employeeContractor/GetVehicleWithDocumentById/fulfilled': (state, action) => {
            state.getVehicleWithDocumentById = ResponseApi(action.payload);
        },
        'employeeContractor/GetAllVehicleByContractorId/fulfilled': (state, action) => {
            state.getAllVehicleByContractorId = ResponseApi(action.payload);
        },
        'employeeContractor/GetAllToContractor/fulfilled': (state, action) => {
            state.getAllToContractor = ResponseApi(action.payload);
        },
        [GetAllEmployeeContracts.fulfilled]: (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.allEmployeeContracts = data;
            }
        },
        'employeeContractor/createEmployeeContractor/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.createEmployeeContractor = data;
            }
        },
        'employeeContractor/getContractorById/fulfilled': (state, action) => {
            state.getContractorById = ResponseApi(action.payload);
        },
        'employeeContractor/getAllContractorDocuments/fulfilled': (state, action) => {
            state.getAllContractorDocuments = ResponseApi(action.payload);
        },
        'employeeContractor/approveContractorDocument/fulfilled': (state, action) => {
            state.approveContractorDocument = ResponseApi(action.payload);
        },
        'employeeContractor/GetAllCommonArea/fulfilled': (state, action) => {
            state.getAllCommonArea = ResponseApi(action.payload);
        },
    },
});

export const { customScduleTime } = employeeContractorSlice.actions;
export const getcustomSchdulTime = (state) => state.EmployeeContractorsSlice.customSchdulTime;

export const getcreateContract = (state) => state.EmployeeContractorsSlice.createContract;
export const getcreateContractV1 = (state) => state.EmployeeContractorsSlice.createContractV1;
export const getcontractAllStatus = (state) => state.EmployeeContractorsSlice.contractAllStatus;
export const getZonetree = (state) => state.EmployeeContractorsSlice.getZonetree;
export const getAllEmployeeContractors = (state) => state.EmployeeContractorsSlice.allEmployeeContractors;
export const getAllContractors = (state) => state.EmployeeContractorsSlice.getAllContractors;
export const getAllWorkSchdule = (state) => state.EmployeeContractorsSlice.getAllWorkSchdule;
export const getWorkTimeAccess = (state) => state.EmployeeContractorsSlice.getWorkTimeAccess;
export const getAllEmployeeContracts = (state) => state.EmployeeContractorsSlice.allEmployeeContracts;
export const contractorDownloadDocument = (state) => state.EmployeeContractorsSlice.contractorDownloadDocument;
export const getWorkShiftByContractID = (state) => state.EmployeeContractorsSlice.WorkShiftByContractID;
export const vehicleWithDocumentById = (state) => state.EmployeeContractorsSlice.getVehicleWithDocumentById;
export const allVehicleByContractorId = (state) => state.EmployeeContractorsSlice.getAllVehicleByContractorId;
export const allToContractor = (state) => state.EmployeeContractorsSlice.getAllToContractor;

export const { ClearGetContractorById } = employeeContractorSlice.actions;

export default employeeContractorSlice.reducer;
